import React, { useState, useContext } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { AuthContext } from "../../../../constants/AuthContext";

const ProfileSetting = () => {
    const [loadingBtnDetails, setLoadingBtnDetails] = useState(false);
    const [loadingBtnImage, setLoadingBtnImage] = useState(false);
    const [loadingBtnPassword, setLoadingBtnPassword] = useState(false);

    const { authUser, setAuthUser } = useContext(AuthContext);
    const token = localStorage.getItem("authToken");

    const [sendFormData, setSendFormData] = useState({
        user_id: authUser?.user_id || "",
        first_name: authUser?.first_name || "",
        last_name: authUser?.last_name || "",
        about: authUser?.about || "",
    });

    const [passwordData, setPasswordData] = useState({
        old_pass: "",
        new_pass: "",
        confirm_pass: "",
    });

    const [profileImage, setProfileImage] = useState(null);

    const [message, setMessage] = useState(null);

    const handleProfileUpdate = async (e) => {
        e.preventDefault();
        setLoadingBtnDetails(true);

        try {
            const res = await axios.post(
                process.env.REACT_APP_WEB_APP_URL + "/api/edit-profile",
                sendFormData,
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            toast.success('Profile updated successfully!');
            setAuthUser(res.data?.data?.userinfo);
        } catch (err) {
            toast.error(err.response?.data?.message || "Failed to update profile");
        } finally{
            setLoadingBtnDetails(false);
        }
    };

    // handle password change
    const handlePasswordChange = async (e) => {
        e.preventDefault();
        setLoadingBtnPassword(true);

        if (passwordData.new_pass !== passwordData.confirm_pass) {
            toast.error('Passwords do not match!');
            setLoadingBtnPassword(false);
            return;
        }

        try {
            await axios.post(
                process.env.REACT_APP_WEB_APP_URL + "/api/profile/change-password",
                passwordData,
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );
            toast.success('Password changed successfully!');
            setPasswordData({ old_pass: "", new_pass: "", confirm_pass: "" });
        } catch (err) {
            toast.error(err.response?.data?.message || "Failed to change password");
        } finally{
            setLoadingBtnPassword(false);
        }
    };

    // handle image update
    const handleImageUpdate = async (e) => {
        e.preventDefault();
        setLoadingBtnImage(true);

        if (!profileImage) {
            toast.error('Please select an image');
            setLoadingBtnImage(false);
            return;
        }

        const imgData = new FormData();
        imgData.append("image", profileImage);

        try {
            const res = await axios.post(
                process.env.REACT_APP_WEB_APP_URL + "/api/profile-image-update",
                imgData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "multipart/form-data",
                    },
                }
            );
            toast.success('Profile image updated successfully!');
            setAuthUser(res.data?.data);
        } catch (err) {
            toast.error(err.response?.data?.message || "Failed to update image");
        } finally{
            setLoadingBtnImage(false);
        }
    };

    return (
        <>
            {/* Profile Settings */}
            <div className="card mb-4">
                <div className="card-header bg-transparent py-3">
                    <h5 className="widget-title m-0">Profile Settings</h5>
                </div>
                <div className="card-body">
                    <form onSubmit={handleProfileUpdate}>
                        <div className="border rounded-4 p-2 mb-3">
                            <div className="d-flex gap-3 align-items-center">
                                <div>
                                    {authUser != null ? (
                                        <img
                                            className="user-image"
                                            src={authUser?.profile_pic}
                                            alt="User"
                                            style={{ width: 80, height: 80, borderRadius: "50%" }}
                                        />
                                    ) : null}
                                </div>
                                <div className="w-100">
                                    <input
                                        type="file"
                                        className="form-control"
                                        onChange={(e) => setProfileImage(e.target.files[0])}
                                    />
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-secondary mt-2"
                                        onClick={handleImageUpdate}
                                        disabled={loadingBtnImage}
                                    >
                                        {loadingBtnImage ? (
                                            <span>
                                                <span className="spinner-border spinner-border-sm me-2"></span>
                                                Updating Image...
                                            </span>
                                        ) : (
                                            "Update Image"
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="row gx-2 gy-2 gy-lg-3">
                            <div className="form-group col-md-12 col-lg-4">
                                <label className="form-label">
                                    First Name <span className="text-danger">*</span>
                                </label>
                                <input
                                    className="form-control"
                                    type="text"
                                    value={sendFormData.first_name}
                                    onChange={(e) => {
                                        setSendFormData({ ...sendFormData, first_name: e.target.value });
                                    }
                                    }
                                    required
                                />
                            </div>
                            <div className="form-group col-md-12 col-lg-4">
                                <label className="form-label">
                                    Last Name <span className="text-danger">*</span>
                                </label>
                                <input
                                    className="form-control"
                                    type="text"
                                    value={sendFormData.last_name}
                                    onChange={(e) => {
                                        setSendFormData({ ...sendFormData, last_name: e.target.value });
                                    }
                                    }
                                    required
                                />
                            </div>
                            <div className="form-group col-md-12 col-lg-4">
                                <label className="form-label">Email</label>
                                <input
                                    className="form-control"
                                    type="email"
                                    value={authUser?.email}
                                    disabled
                                />
                            </div>
                            <div className="form-group col-md-12 col-lg-4">
                                <label className="form-label">Mobile</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    value={authUser?.phone_code + ' ' + authUser?.mobno}
                                    disabled
                                />
                            </div>
                            <div className="form-group col-xl-12">
                                <label className="form-label">About</label>
                                <textarea
                                    className="form-control"
                                    rows="3"
                                    value={sendFormData.about || authUser?.about}
                                    onChange={(e) => {
                                        setSendFormData({ ...sendFormData, about: e.target.value });
                                    }
                                    }
                                />
                            </div>
                            <div className="form-group col-xl-12 text-end mt-4">
                                <button className="btn btn-primary" type="submit" disabled={loadingBtnDetails}>
                                    {loadingBtnDetails ? (
                                        <span>
                                            <span className="spinner-border spinner-border-sm me-2"></span>
                                            Updating Details...
                                        </span>
                                    ) : (
                                        "Update Profile"
                                    )}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            {/* Change Password */}
            <div className="card mb-4">
                <div className="card-header bg-transparent py-3">
                    <h5 className="widget-title m-0">Change Password</h5>
                </div>
                <div className="card-body">
                    <form onSubmit={handlePasswordChange}>
                        <div className="row gx-2 gy-2 gy-lg-3">
                            <div className="form-group col-md-12 col-lg-4">
                                <label className="form-label">Old Password *</label>
                                <input
                                    className="form-control"
                                    type="password"
                                    value={passwordData.old_pass}
                                    onChange={(e) =>
                                        setPasswordData({ ...passwordData, old_pass: e.target.value })
                                    }
                                    required
                                />
                            </div>
                            <div className="form-group col-md-12 col-lg-4">
                                <label className="form-label">New Password *</label>
                                <input
                                    className="form-control"
                                    type="password"
                                    value={passwordData.new_pass}
                                    onChange={(e) =>
                                        setPasswordData({ ...passwordData, new_pass: e.target.value })
                                    }
                                    required
                                />
                            </div>
                            <div className="form-group col-md-12 col-lg-4">
                                <label className="form-label">Confirm Password *</label>
                                <input
                                    className="form-control"
                                    type="password"
                                    value={passwordData.confirm_pass}
                                    onChange={(e) =>
                                        setPasswordData({
                                            ...passwordData,
                                            confirm_pass: e.target.value,
                                        })
                                    }
                                    required
                                />
                            </div>
                            <div className="form-group col-12 text-end">
                                <button 
                                    type="submit"
                                    className="btn btn-primary"
                                    disabled={loadingBtnPassword}
                                >
                                    {loadingBtnPassword ? (
                                        <span>
                                            <span className="spinner-border spinner-border-sm me-2"></span>
                                            Updating Password...
                                        </span>
                                    ) : (
                                        "Update Password"
                                    )}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
};

export default ProfileSetting;
